/* cali 2026-10-14 gallery-fit: open a product gallery video full screen.
   Gallery videos play muted, on a loop, with no controls. The button over each one
   (snippets/media.liquid, .cali-video-full) opens it full screen with sound and controls;
   leaving full screen puts it back to the muted loop. iPhone Safari has no element full screen,
   so it uses the video's own player (webkitEnterFullscreen). Loaded only on product pages whose
   gallery has a video. */
(function () {
  if (window.__caliGalleryFit) return;
  window.__caliGalleryFit = true;

  function toInline(video) {
    video.removeAttribute('controls');
    video.muted = true;
    delete video.dataset.caliFull;
  }

  function open(video) {
    video.dataset.caliFull = '1';
    video.setAttribute('controls', '');
    video.muted = false;
    var played = video.play();
    if (played && typeof played.catch === 'function') played.catch(function () {});
    var request = video.requestFullscreen || video.webkitRequestFullscreen;
    if (request) {
      var result = request.call(video);
      if (result && typeof result.catch === 'function') {
        result.catch(function () {
          if (video.webkitEnterFullscreen) video.webkitEnterFullscreen(); else toInline(video);
        });
      }
    } else if (video.webkitEnterFullscreen) {
      video.webkitEnterFullscreen();
    } else {
      toInline(video);
    }
  }

  // Capture phase, so the slider's own click handling cannot swallow it.
  document.addEventListener('click', function (evt) {
    var button = evt.target.closest && evt.target.closest('.cali-video-full');
    if (!button) return;
    var wrapper = button.closest('.product__video-wrapper');
    var video = wrapper && wrapper.querySelector('video');
    if (!video) return;
    evt.preventDefault();
    evt.stopPropagation();
    open(video);
  }, true);

  function onExit() {
    if (document.fullscreenElement || document.webkitFullscreenElement) return;
    var videos = document.querySelectorAll('.product__video-wrapper video[data-cali-full]');
    for (var i = 0; i < videos.length; i++) toInline(videos[i]);
  }
  document.addEventListener('fullscreenchange', onExit);
  document.addEventListener('webkitfullscreenchange', onExit);
  // iPhone: the video's own full-screen player ends with this event on the video element.
  document.addEventListener('webkitendfullscreen', function (evt) {
    if (evt.target && evt.target.dataset && evt.target.dataset.caliFull) toInline(evt.target);
  }, true);
})();
